import { Component, OnInit } from '@angular/core'
import { UserContextService } from '@core/service/user-context.service'

@Component({
  selector: 'app-modal-confirmacao-termos',
  templateUrl: './modal-confirmacao-termos.component.html',
})
export class ModalConfirmacaoTermosComponent implements OnInit {
  constructor(private userContext: UserContextService) {}

  private isResidente: boolean

  ngOnInit(): void {
    this.isResidente = this.userContext.isResidente()
  }

  getIsResidente(): boolean {
    return this.isResidente
  }
}
